// Всплывающая карточка у точки клика, целиком в окне (как popShow/popFit в оболочке).
import { useLayoutEffect, useRef, type ReactNode } from 'react';

export type Anchor = { x: number; y: number };

export function Pop({ at, title, onClose, children, width = 380 }:
  { at: Anchor; title: ReactNode; onClose: () => void; children: ReactNode; width?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.maxHeight = (window.innerHeight - 16) + 'px';
    const w = el.offsetWidth || width, h = el.offsetHeight || 0;
    el.style.left = Math.max(8, Math.min(at.x, window.innerWidth - w - 8)) + 'px';
    el.style.top = Math.max(8, Math.min(at.y + 8, window.innerHeight - h - 8)) + 'px';
  }, [at, width]);
  return (
    <div ref={ref} className="pw-pop" style={{ maxWidth: width }}>
      <b>{title}</b>
      {children}
      <div className="pw-row" style={{ marginTop: 10 }}>
        <span style={{ flex: 1 }} />
        <button className="sec" onClick={onClose}>Закрыть</button>
      </div>
    </div>
  );
}

/** Точка клика для карточки */
export function at(e: { clientX: number; clientY: number }): Anchor {
  return { x: e.clientX, y: e.clientY };
}
